// src/constant/data.jsx

import { IMAGES } from "./Image";
import { IoSpeedometerOutline } from "react-icons/io5";
import { TbAutomaticGearbox } from "react-icons/tb";
import { TbSteeringWheel } from "react-icons/tb";
import { TfiPaintBucket } from "react-icons/tfi";
import { PiEngineLight } from "react-icons/pi";

export const bannerData = [
  {
    id: 1,
    title1: "Safety Certified",
    title2: "Auction Cars",
    title3: "Now Open to Public",
    image: IMAGES.heroBanner01, // this will match IMAGES key
  },
  {
    id: 2,
    title1: "Reliable & Secure",
    title2: "Vehicle Auctions",
    title3: "Bid with Confidence",
    image: IMAGES.heroBanner01, // this will match IMAGES key
  },
  {
    id: 3,
    title1: "Top Deals",
    title2: "Used Cars",
    title3: "At Unbeatable Prices",
    image: IMAGES.heroBanner01, // this will match IMAGES key
  },
  {
    id: 4,
    title1: "Certified Cars",
    title2: "All Models",
    title3: "Available Now",
    image: IMAGES.heroBanner01, // this will match IMAGES key
  },
];

export const cardData = [
  {
    id: 1,
    category: "Chevrolet",
    status: "Upcoming",
    endDate: "2025-10-20T12:00:00",
    title: "1995 Porsche 928 GTS",
    productDes:
      "Clearly state your pricing structure, payment terms and and any additional charges. Specifying when & payment invoices will be issued.",
    startingBid: 3356,
    image: IMAGES.Auction_Image,
    images: [
      IMAGES.Auction_Image,
      IMAGES.Auction_Image,
      IMAGES.Auction_Image,
      IMAGES.Auction_Image,
    ],
    buttonText: "Bid Now",
    buttonColor: "green",
    lotNumber: "LOT #654321",
    itemCondition: "New",
    tags: ["Ford", "Hyundai"],
    sku: "ICNB-34",

    // Car Overview
    carOverview: [
      { icon: IoSpeedometerOutline, text: "89,713 Km (Indicated)" },
      { icon: TbAutomaticGearbox, text: "Automatic" },
      { icon: TbSteeringWheel, text: "RHD" },
      { icon: TfiPaintBucket, text: "Almandine Blue" },
      { icon: PiEngineLight, text: "3.0L Inline-Six" },
    ],

    // Lot Overview (3 items)
    lotOverview: [
      { img: IMAGES.log_img, text: "LOT #654321" },
      { img: IMAGES.lot_overview_img, text: "Trade Person Name" },
      { img: IMAGES.lot_overview_flag, text: "California, USA" },
    ],

    // Seller (1 item)
    seller: {
      img: IMAGES.seller_profile_img,
      name: "John Doe Seller", // Dummy text abhi
      link: "/seller/john-doe", // Baad me dynamic kar lena
    },

    // ✅ Galleries (Exterior, Interior, Mechanical, Documents)
    galleries: {
      exterior: [
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
      ],
      interior: [
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
      ],
      mechanical: [
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
        IMAGES.Auction_Image,
      ],
      documents: [IMAGES.Auction_Image, IMAGES.Auction_Image],
    },
  },
  {
    id: 2,
    category: "BMW",
    status: "Upcoming",
    endDate: "2025-08-15T10:30:00",
    title: "Another car auction going live.",
    startingBid: "2,500.00",
    image: IMAGES.Auction_Image,
    buttonText: "Bid Now",
    buttonColor: "blue",
    lotNumber: "LOT #67890",
  },
  {
    id: 3,
    category: "Audi",
    status: "expired",
    endDate: "2025-06-15T10:30:00",
    title: "Another car auction going live.",
    startingBid: "2,500.00",
    image: IMAGES.Auction_Image,
    buttonText: "Bid Now",
    buttonColor: "blue",
    lotNumber: "LOT #11111",
  },
  {
    id: 4,
    category: "Ford",
    status: "expired",
    endDate: "2025-06-15T10:30:00",
    title: "Another car auction going live.",
    startingBid: "2,500.00",
    image: IMAGES.Auction_Image,
    buttonText: "Bid Now",
    buttonColor: "blue",
    lotNumber: "LOT #22222",
  },
  {
    id: 5,
    category: "Tesla",
    status: "expired",
    endDate: "2025-06-15T10:30:00",
    title: "Another car auction going live.",
    startingBid: "2,500.00",
    image: IMAGES.Auction_Image,
    buttonText: "Bid Now",
    buttonColor: "blue",
    lotNumber: "LOT #33333",
  },
  {
    id: 6,
    category: "Lexus",
    status: "expired",
    endDate: "2025-06-15T10:30:00",
    title: "Another car auction going live.",
    startingBid: "2,500.00",
    image: IMAGES.Auction_Image,
    buttonText: "Bid Now",
    buttonColor: "blue",
    lotNumber: "LOT #44444",
  },
];

// categoryData.js
export const categoryData = [
  {
    id: 1,
    image: IMAGES.bmw, // apne assets me jo category images hain wo use karo
    name: "BMW",
  },
  {
    id: 2,
    image: IMAGES.Chevrolet,
    name: "Chevrolet",
  },
  {
    id: 3,
    image: IMAGES.Ferrari,
    name: "Ferrari",
  },
  {
    id: 4,
    image: IMAGES.ford,
    name: "Ford",
  },
  {
    id: 5,
    image: IMAGES.honda,
    name: "Honda",
  },
  {
    id: 6,
    image: IMAGES.hyundai,
    name: "Hyundai",
  },

  {
    id: 7,
    image: IMAGES.hyundai,
    name: "Other Sliders",
  },
];
